declare namespace $ {

	export class $mol_icon_hand_back_right_outline extends $mol_icon {
		path( ): string
	}
	
}

//# sourceMappingURL=outline.view.tree.d.ts.map